export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/about": [3],
		"/analyse": [4],
		"/downloads": [5],
		"/explore": [6],
		"/imprint": [7],
		"/lcvp-browse": [9],
		"/lcvp-display": [10],
		"/lcvp": [8],
		"/learn": [11],
		"/lifegate": [12],
		"/login": [13],
		"/logout": [14],
		"/naijaflo-browse": [15],
		"/naijaflo-display": [16],
		"/query_builder": [17],
		"/register": [18],
		"/search": [19],
		"/smon_viz": [20],
		"/test": [21],
		"/workflows": [22]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';